import { Component, ElementRef, ViewChild, OnInit, Input, ChangeDetectorRef, HostListener } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "../../service/app.layout.service";
import { AuthService } from 'src/app/pages/auth/services/auth.service';
import { NavigationExtras, Router } from '@angular/router';
import { LocalStorageService } from '../../service/local-storage.service';
import { RolesService } from 'src/app/pages/roles/services/roles.service';
import { MessageService } from 'primeng/api';
import { CompanyService } from 'src/app/pages/company-detail/service/company.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./topbar.component.scss']
})
export class AppTopBarComponent implements OnInit {

    items: MenuItem[] = [];
    @Input() userImage!: any; 
    userName:any;
    roleId:any;
    isFrozenColumn:boolean = false;
    dailyReportDialogVisible = false;
    isDailyReportLoading = false;
    companyReportEmails: string[] = [];
    emailTimeOptions: { label: string; value: string }[] = [];
    selectedEmailTime = '';
    dailyReportError = '';

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;

    constructor(
        public layoutService: LayoutService,
        private _authService: AuthService,
        public _router: Router,
        private _localStorage:LocalStorageService,
        private cdr: ChangeDetectorRef ,
        private _roleService:RolesService,
        private _messageService: MessageService,
        private _companyService: CompanyService
    ) { }

    ngOnInit(): void {
     const topbar = document.querySelector('.layout-topbar')
     console.log(topbar)
        this.checkViewportWidth(); 
        this.getDataFromLocalStorage();
        this.buildEmailTimeOptions();
        this.initializeItemsList();
        this._roleService.userImage$.subscribe((image) => {
          this.setDataAndDetectChanges(image);
        });
    }

    getDataFromLocalStorage(){
      this.userImage = this._localStorage.getValue("photo");
      this.userName = this._localStorage.getValue("username");
      this.roleId = parseInt(this._localStorage.getValue("role_id") || '0'); // Default to 0 if roleId is not available
    }

    setDataAndDetectChanges(image: any) {
      this.userImage = image;
      console.log("passed user image", this.userImage)
      this.cdr.detectChanges();
    }

    initializeItemsList() {
        this.items = [
          {
            label: 'Profile Settings', icon: 'pi pi-cog', command: (event)=> {          
              let navigationExtras: NavigationExtras = {
                state: {
                    selfUser: true
                }
            };
            this._router.navigate(['/profile-detail'], navigationExtras);
            }
          },
          {
            label: 'Daily Report Setting',
            icon: 'pi pi-calendar',
            command: () => this.openDailyReportSetting()
          },
          {
            label: 'Company Profile',
            icon: 'pi pi-building',
            command: () => {
                if (this.roleId === 1 || this.roleId === 2) {
                    this._router.navigate(['/company-detail']);
                } else {
                    console.log('Hiding Change Company option');
                }
            },
            visible: this.isChangeCompanyVisible()
        },
          {
            label: 'Logout', icon: 'pi pi-fw pi-power-off', command: (event)=> {          
              this.logout()
            }
          },
        ];
    }

    logout() {
        const refreshTokenStr = localStorage?.getItem('r_ad_token');
        const refreshToken = refreshTokenStr ? JSON.parse(refreshTokenStr) : null;
        // this._authService.logout(refreshToken).subscribe(res => {
            // if (res?.error) {
            // }
            //  else {
               this._localStorage.deleteAll();
                this._router?.navigate(['/login']);
            // }
        // })
    }


    isChangeCompanyVisible(): boolean {
      const roleId = parseInt(this.roleId); // Ensure roleId is of type number
      return roleId === 1 || roleId === 2;
  }

  openDailyReportSetting() {
    this.dailyReportError = '';
    this.dailyReportDialogVisible = true;
    const companyId = this._localStorage.getValue('company_id');

    if (!companyId) {
      this.dailyReportError = 'Company details are unavailable.';
      return;
    }

    this.isDailyReportLoading = true;
    this._companyService.getCompanyReportEmail(companyId).subscribe({
      next: (res) => {
        const reportData = res?.result || res || {};
        const emailString = reportData?.company_report_email || '';
        this.companyReportEmails = this.normalizeEmails(emailString);
        this.selectedEmailTime = this.utcTimeToLocalTime(reportData?.email_time);
        this.isDailyReportLoading = false;
      },
      error: () => {
        this.isDailyReportLoading = false;
        this.dailyReportError = 'Unable to load the daily report setting.';
      }
    });
  }

  buildEmailTimeOptions() {
    this.emailTimeOptions = Array.from({ length: 24 }, (_, hour) => {
      const value = `${String(hour).padStart(2, '0')}:00:00`;
      return { label: `${String(hour).padStart(2, '0')}:00`, value };
    });
  }

  normalizeEmails(value: string): string[] {
    if (!value) {
      return [];
    }

    return value
      .split(',')
      .map((email) => email.trim())
      .filter((email) => !!email);
  }

  normalizeTime(value: string): string {
    if (!value) {
      return '09:00:00';
    }

    const [hours] = value.split(':');
    const hourNumber = Number(hours);
    if (Number.isNaN(hourNumber)) {
      return '09:00:00';
    }
    return `${String(hourNumber).padStart(2, '0')}:00:00`;
  }

  utcTimeToLocalTime(value: string): string {
    if (!value) {
      return '09:00:00';
    }

    const [hours, minutes = '00', seconds = '00'] = value.split(':');
    const utcHour = Number(hours);
    if (Number.isNaN(utcHour)) {
      return '09:00:00';
    }

    const utcDate = new Date();
    utcDate.setUTCFullYear(2000, 0, 1);
    utcDate.setUTCHours(utcHour, Number(minutes), Number(seconds), 0);

    return `${String(utcDate.getHours()).padStart(2, '0')}:${String(utcDate.getMinutes()).padStart(2, '0')}:${String(utcDate.getSeconds()).padStart(2, '0')}`;
  }

  localTimeToUtcTime(value: string): string {
    if (!value) {
      return '09:00:00';
    }

    const [hours, minutes = '00', seconds = '00'] = value.split(':');
    const localHour = Number(hours);
    if (Number.isNaN(localHour)) {
      return '09:00:00';
    }

    const localDate = new Date();
    localDate.setFullYear(2000, 0, 1);
    localDate.setHours(localHour, Number(minutes), Number(seconds), 0);

    return `${String(localDate.getUTCHours()).padStart(2, '0')}:${String(localDate.getUTCMinutes()).padStart(2, '0')}:${String(localDate.getUTCSeconds()).padStart(2, '0')}`;
  }

  isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  validateDailyReportEmails(): boolean {
    const invalidEmail = this.companyReportEmails.find((email) => !this.isValidEmail(email));
    if (invalidEmail) {
      this.dailyReportError = `Invalid email: ${invalidEmail}`;
      return false;
    }
    this.dailyReportError = '';
    return true;
  }

  saveDailyReportSetting() {
    if (!this.validateDailyReportEmails()) {
      return;
    }

    const companyId = this._localStorage.getValue('company_id');
    if (!companyId) {
      this.dailyReportError = 'Company details are unavailable.';
      return;
    }

    this.isDailyReportLoading = true;
    this._companyService.updateCompanyReportEmail(companyId, {
      company_report_email: this.companyReportEmails.join(','),
      email_time: this.localTimeToUtcTime(this.selectedEmailTime || '09:00:00')
    }).subscribe({
      next: () => {
        this.isDailyReportLoading = false;
        this.dailyReportDialogVisible = false;
        this._messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Daily report setting saved.'
        });
      },
      error: () => {
        this.isDailyReportLoading = false;
        this.dailyReportError = 'Unable to save the daily report setting.';
      }
    });
  }

  removeDailyReportEmail(index: number) {
    this.companyReportEmails = this.companyReportEmails.filter((_, currentIndex) => currentIndex !== index);
    this.validateDailyReportEmails();
  }

  onDailyReportEmailAdd() {
    this.validateDailyReportEmails();
  }

  onDailyReportEmailRemove() {
    this.validateDailyReportEmails();
  }

  isDailyReportEmailInvalid(email: string): boolean {
    return !this.isValidEmail(email);
  }

  checkViewportWidth() {
    this.isFrozenColumn = window.innerWidth < 500;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkViewportWidth();
  }
}
